/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Plus = ({ color = 'forest', height = 20 }) => {
  return (
    <svg width={20} height={height} viewBox="0 0 20 20" sx={{ fill: color }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 9v2h-9v9H9v-9H0V9h9V0h2v9h9z"
      />
    </svg>
  )
}

Plus.propTypes = {
  color: string,
  height: number,
}

export default Plus
